import ApplicationController from "./application_controller";

export default class extends ApplicationController {

    static targets = ["hm0_output"];

    connect() {
        console.log("Liste Dappel JS en cours ...");
        super.connect();
        if ($("#search").length && $("#quick_sort").length) {
            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });

            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                console.log(
                    "From intervention_controller.js =======> ",
                    element.scrollTop
                );
                document.getElementById("scrollevel").value = element.scrollTop;
            });

            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const entretiensRhParam = url.searchParams.get("previous_record");

            if (entretiensRhParam != null) {
                var trElement = $("#entretiens_rh_" + entretiensRhParam);
                $("#entretiens_rh_" + entretiensRhParam + " td").addClass("highlighted-td");
                $("#entretiens_rh_" + entretiensRhParam).get(0).scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }

    toggle() {
        if (this.isopened != 3) {
            this.initZindex()
            this.isopened = 3;
            this.fct($("#mySidebar").css("width") > "0px").then((res) => {
                if (res == true) {
                    this.isopened = 1;
                } else {
                    this.isopened = 0;
                }
            });
        } else {
            /*********/
        }
    }

    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }





}


